// extracted by mini-css-extract-plugin
export var wrapper = "input-module--wrapper--0Bfz3";
export var input = "input-module--input--phfGw";
export var icon = "input-module--icon--DwYGe";
export var fadein = "input-module--fadein--YvZur";